/**
 * Table Notes
 * Note icon used by some tables to show if record
 * has notes attached
 */
import React from 'react';

import Icon from '@components/Icon/Icon';

export const TableNote: React.FC<{ value: boolean }> = ({ value = false }) => {
  if (!value) {
    return null;
  }

  return (
    <Icon color="text.secondary" name="file-lines" style={{ fontSize: 20 }} />
  );
};
